import { styled } from 'styled-components';

import {
  bodyText,
  colors,
  cssBreakpoints,
  h4Text,
  transition,
} from 'theme/theme';

export const TileGridBlockTileLink = styled.a<{ $isTabbing: boolean }>`
  transition: all ${transition};
  max-width: 100%;
  padding: 20px;
  flex-shrink: 0;
  text-decoration: none;
  color: ${colors.mediumContentGrey};

  &:hover,
  &:focus {
    color: ${colors.mediumContentGrey};
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    &:hover,
    &:focus {
      box-shadow: 0 2px 6px rgb(0 0 0 / 20%);
      border-radius: 3px;

      h4 {
        text-decoration: underline;
      }
    }
  }

  ${({ $isTabbing }) => !$isTabbing && `outline: none;`}
`;

export const TileGridBlockTileImageHolder = styled.div`
  /* prevent dragging image */
  pointer-events: none;
  overflow: hidden;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const TileGridBlockTileHeading = styled.h4`
  ${h4Text};

  margin-top: 0;
  margin-bottom: 8px;
  line-height: 1.6em;
  color: ${colors.brandBlue};
`;

export const TileGridBlockTileSubHeading = styled.p`
  ${bodyText};

  margin: 0;
  line-height: 1.6em;
`;
